<template>
  <b-container>
    <Nav
    :statusoptions="statusoptions"
    :showoverlay="showoverlay"
    @statusemit="updateStatusFilter"
    @text-filter-emit="updateTextFilter"
    @sortorderemit="updateSortParams"
    @show-filters-emit="showFilters">
    </Nav>
    <div v-if="showoverlay" style="z-index: 9999; position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);">
      <b-spinner style="width: 3rem; height: 3rem;" label="Please wait..."></b-spinner>
    </div>
    <b-overlay id="orderscrn" class="overspin" :show="showoverlay" rounded="sm" fixed>
      <b-row>
        <b-col order="1" cols="6" md="9" lg="2">Show {{ statusoptions[1].text }}?</b-col>
        <b-col order="3" order-lg="2" cols="6" md="4" lg="2">
          <b-form-radio-group
            v-model="filterSubmitted"
            :options="filterSubmittedOptions"
            button-variant="outline-dark"
            buttons
            @input="filterSubmittedOrders()"
          ></b-form-radio-group>
        </b-col>
        <b-col order="2" order-lg="4" cols="6" md="3" lg="1"><label for="ord-ordnum">Ord # </label></b-col>
        <b-col order="5" cols="6" md="3" offset-md="1" offset-lg="0"><b-form-input id="ord-ordnum" v-model="ordnum" @blur="updateTextFilter(ordnum, 'ordnum')"></b-form-input></b-col>
        <b-col order="6" order-md="4" order-lg="3" md="4" class="pt-2 pt-md-0"><b-pagination v-model="currentPage" :total-rows="total_orders" :per-page="limit" align="center" @change="changePage()"></b-pagination></b-col>
      </b-row>
      <b-card-group columns style="column-count: 1;" v-if="total_orders>0">
        <OrderInfo
        v-for="order of orders"
        v-bind:key="order.id"
        :order="order"
        :statusoptions="statusoptions"
        @emit-fetch-orders="fetchOrders"
        @emit-pay-order="openPaymentModal">
      </OrderInfo>
      </b-card-group>
      <b-pagination v-model="currentPage" :total-rows="total_orders" :per-page="limit" align="center" @change="changePage()"></b-pagination>
      <p style="text-align: center;">Total orders returned: {{ total_orders }}</p>
    </b-overlay>

    <b-modal
      id="mod-payment-type"
      title="Choose Payment Type"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc>
      <!-- @hidden="emitSwitchOverlay(false)"> -->
      <b-card-group deck style="column-count: 2;">
        <ChooseCard
          v-for="option of paymentoptions"
          v-bind:key="option.id"
          :option="option"
          @emit-card-choice="paymentChosen">
        </ChooseCard>
      </b-card-group>
      <b-row class="py-4" v-if="allowSplit"><b-col>
        <b-button
          block
          size="lg"
          variant="primary"
          @click="$bvModal.hide('mod-payment-type'); openSplitModal=true">
          Split Bill
        </b-button>
      </b-col></b-row>
    </b-modal>

    <CustomerTipModal :order_total="paymentTotal" @emit-post-tip="setTipFromModal"></CustomerTipModal>

    <SplitBill
      v-if="openSplitModal"
      :selectedOrderTotal="selectedOrder.total"
      :splitPaidDetails="splitPaidDetails"
      @emit-split-payment="updateSplitPayments"
      @emit-close-split-modal="cleanCloseSplitModal"
      @emit-partially-paid="setPartiallyPaid"
    ></SplitBill>

    <StripeTerminal
      v-if="proceedStripeTerminal"
      :payment_intent="payment_intent"
      :orderlines="selectedOrder.order_lines"
      :order_total="paymentTotal"
      :tax_total="selectedOrder.tax"
      :fees="selectedOrder.surcharge"
      :customTip="customTip"
      :order_type="selectedOrder.order_type.id"
      @payment-finish="endTerminalPayment"
      @switch-overlay="switchOverlay">
    </StripeTerminal>

    <CashCalculator
      v-if="proceedCashCalculator"
      :order_total="paymentTotal"
      @emit-close-modal="endCashPayment">
    </CashCalculator>

  </b-container>
</template>


<script>
import Nav from '@/components/Nav.vue'
import OrderInfo from '@/components/OrderInfo.vue'
import StripeTerminal from '@/components/PlaceOrder/StripeTerminal.vue'
import ChooseCard from '@/components/PlaceOrder/ChooseCard.vue'
import CashCalculator from '@/components/PlaceOrder/CashCalculator.vue'
import SplitBill from '@/components/SplitBill.vue'
import CustomerTipModal from '@/components/PlaceOrder/CustomerTipModal.vue'
import moment from 'moment'

export default {
  name: "Orders",
  components: {
    Nav,
    OrderInfo,
    StripeTerminal,
    ChooseCard,
    CashCalculator,
    SplitBill,
    CustomerTipModal
  },
  data() {
    var audio = new Audio(require('../assets/cash-register-cha-ching-9.mp3'))
    return {
      orders: [],
      current_location: 0,
      status_select: null,
      notification: '',
      total_orders: 0,
      limit: 10,
      currentPage: 1,
      showoverlay: false,
      noReceiptAlert: false,
      statusfilter: '',
      cusnamefilter: '',
      cusnumfilter: '',
      textfilter: '',
      sortparams: '&sortby=-time_taken',
      timer: '',
      orderCount: 0,
      paymentoptions: [
        { id: 1, name: 'Cash', image_path: 'https://storage.googleapis.com/payoo-vendor-images/pay-by-cash.png' },
        { id: 3, name: 'Card', image_path: 'https://storage.googleapis.com/payoo-vendor-images/pay-by-card.png' }
      ],
      proceedStripeTerminal: false,
      proceedCashCalculator: false,
      payment_intent: [],
      selectedOrder: [],
      allowSplit: false,
      openSplitModal: false,
      splitPayment: {},
      splitPaidDetails: {},
      paymentTotal: 0.00,
      partiallyPaid: false,
      filterSubmittedOptions: [ { text: 'Yes', value: 1 }, { text: 'No', value: 2 }, { text: 'All', value: 3 } ],
      filterSubmitted: 3,
      ordnum: '',
      lastPollDateTime: moment.utc(),
      initalOrderPoll: true,
      customTip: 0,
      audio
    };
  },

  computed: {
    filteredorders: function() {
      return this.orders.filter(order=>order.order_status!=8);
    },

    // all pagination, filtering and sorting info collected here for housekeeping purposes
    urlext: function() {
      // set status filter to default to exclude status == 1
      const statusfilter = (this.statusfilter == '') ? '&status=notin:1' : this.statusfilter;
      return "?page="+this.currentPage+"&limit="+this.limit+statusfilter+this.textfilter+this.sortparams;
    },

    taxes_tips_fees: function() {
      if (Object.keys(this.selectedOrder).length>0) {
        return Number(this.selectedOrder.tax) + Number(this.selectedOrder.tip) + Number(this.selectedOrder.surcharge)
      } else {
        return 0;
      }
    },

    statusoptions: function() {
      var statopt = [
        {text: 'Update Status', value: 0, disabled: true},
        {text: 'Unpaid', value: 2},
        {text: 'Placed', value: 3},
        {text: 'Paid', value: 6},
        {text: 'Ready to Collect', value: 7},
        {text: 'Complete', value: 8}
      ]
      // Customisation for El Chingon
      if (this.current_location==18) {
        const idx = statopt.findIndex((s=>s.value==2));
        statopt[idx].text='NOT PAID';
      }
      return statopt;
    },

  },

  methods: {
    switchOverlay(overlay)  {
        this.overlay=overlay;
    },

    async setTipFromModal(tip, enteredBool) {
      this.showoverlay=true;
      this.$bvModal.hide('mod-payment-type')
      tip = (enteredBool==true) ? tip : 0;
      // this.tip_select= await -1;
      this.customTip = await tip;
      await this.updateOrder(3);
      this.$bvModal.hide('cust-tip-modal')
      this.proceedStripeTerminal=true;
    },

    filterSubmittedOrders() {
      localStorage.submittedFilter = this.filterSubmitted;
      if (this.filterSubmitted==1) {
        this.updateStatusFilter([2]);
      } else if (this.filterSubmitted==2) {
        this.updateStatusFilter([3,6,7,8]);
      } else {
        this.updateStatusFilter([]);
      }
    },

    setPartiallyPaid(pp) {
      this.partiallyPaid = pp;
      if (!this.partiallyPaid) {
        this.$bvModal.hide('mod-split-bill');
      }
    },

    updateSplitPayments(splitpayments) {
      this.allowSplit=false;
      this.splitPaidDetails={};
      this.splitPayment = splitpayments;
    },

    cleanCloseSplitModal() {
      this.openSplitModal = false;
    },

    openPaymentModal(order) {
      // pass order into this.selectedOrder
      this.selectedOrder = order;
      this.paymentTotal = order.total;
      this.allowSplit=true;
      this.$bvModal.show('mod-payment-type');
    },

    paymentChosen(payment_type) {
      if (payment_type==3) {
        this.$bvModal.show('cust-tip-modal');
      } else if (payment_type==1){
        this.updateOrder(payment_type)
      }
    },

    /*
    Updates an existing order and generates a payment_intent.
    */
    async updateOrder(payment_type) {
      this.showoverlay = true;
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();
      var config = {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      };
      var payment_intent_id = (this.selectedOrder.payment_intent_id) ? this.selectedOrder.payment_intent_id : "create";
      var body = {
        "payment_intent_id": payment_intent_id,
        "payment_type": payment_type,
      }
      // If a CASH order, update the order status to PAID
      if (payment_type==1) {
        body["order_status"]=6;
      }
      if (this.customTip!=0) {
        body["tip"] = -1;
        body["custom_tip"] = this.customTip;
      }
      if (Object.keys(this.splitPayment).length>0) {
        body['split_payment_amount'] = this.splitPayment.Amount;
      }
      const { data } = await this.$api.patch('/locations/'+this.current_location+'/orders/'+this.selectedOrder.id, body, config);
      try {
        // console.log(response)
        if (data.success == true || data.created == true) {
          // If it's a split payment
          if (Object.keys(this.splitPayment).length>0) {
            // set splitPaidDetails for use in Modal
            this.$set(this.splitPaidDetails, 'Line', this.splitPayment.Line)
            this.$set(this.splitPaidDetails, 'Amount', this.splitPayment.Amount)
            this.paymentTotal = this.splitPayment.Amount;
            this.showoverlay = false;
          }
          this.payment_intent = await data;
          this.takePayment(payment_type);
        } else if (data.invaliditem==true) {
          this.$bvModal.msgBoxOk('The order contains an item - '+data.item+', which is not available on the selected day or is out of stock. Please choose something else from our menu and resubmit', {
            title: 'Selected item unavailable',
            centered: true
          })
        }
      } catch(e) {
        console.log(e);
      } finally {
        this.showoverlay = false;
      }
    },

    takePayment(payment_type) {
      this.showoverlay = false;
      // If it's a Stripe Terminal payment
      if (payment_type==3) {
        this.proceedStripeTerminal=true;
      } else if (payment_type==1){
        this.proceedCashCalculator=true;
      }
    },

    endCashPayment() {
      this.proceedCashCalculator=false;
      // It's a Cash order - close the modal and reset the order page
      this.$bvModal.hide('mod-payment-type');
      // ensure the order is not stil in the middle of a "split payment" before reloading
      if (!this.partiallyPaid) {
        this.fetchOrders();
      }
    },

    //GET THE CURRENT TIME ON THE CLIENT BROWSER IN UTC
    getCurrentTimeUTC(){
      //RETURN:
      //      = number of milliseconds between current UTC time and midnight of January 1, 1970
      return moment.utc()

    },

    endTerminalPayment() {
      this.$bvModal.hide('mod-payment-type');
      this.$bvModal.hide('stripe-terminal');
      this.proceedStripeTerminal=false;
      setTimeout(function () { this.fetchOrders() }.bind(this), 2000)
    },

    async fetchLocations() {
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      // Use Axios to make a call to the API
      const { data } = await this.$api.get("locations", {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      });
      try {
        const locations = data.locations;
        const sortedlocations = await locations.sort((a,b) => a.id - b.id);
        this.current_location = await sortedlocations[0].id;
        // set order count to 0 before polling for new orders / updating order list
        this.orderCount = 0;
        this.pollForOrders()
      } catch(e) {
        console.log(e);
        this.showoverlay = false;
      }
    },

    async pollForOrders() {
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();
      var config = {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      };
      var body = {"order_count": this.orderCount};
      // check to see if there are any new orders for this location
      const { data } = await this.$api.post('locations/'+this.current_location+'/orders', body, config);
      if (data.new_order == true) {
        this.orderCount = data.order_count;
        if(this.initalOrderPoll == true){
          this.fetchOrders();
        }
        else{
          this.fetchNewOrders();
        }
      }
    },

    async fetchOrders() {
      this.showoverlay = true;

      try {
        //Get the current UTC date/time
        let currentDateTime = this.getCurrentTimeUTC();

        // Get the access token from the auth wrapper
        const token = await this.$auth.getTokenSilently();

        // Use Axios to make a call to the API
        const { data } = await this.$api.get("locations/"+this.current_location+"/orders"+this.urlext, {
          headers: {
            Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
          }
        });
        this.orders = data.orders;
        this.total_orders = data.total_orders;
        this.initalOrderPoll = false;
        this.lastPollDateTime = currentDateTime;
      }
      catch(e) {
        console.log(e);
      }
      this.showoverlay = false;
    },

    async fetchNewOrders() {
      this.showoverlay = true;
      try {
        //Get the current UTC date/time
        let currentDateTime = this.getCurrentTimeUTC();

        // Get the access token from the auth wrapper
        const token = await this.$auth.getTokenSilently();

        // Use Axios to make a call to the API
        const { data } = await this.$api.get("locations/"+this.current_location+"/orders" +this.urlext + "&datefrom=gte:"+this.lastPollDateTime+"&dateto=lte:" + currentDateTime, {
          headers: {
          // send the access token through the 'Authorization' header
            Authorization: `Bearer ${token}`
          }
        });
        this.orders = data.orders.concat(this.orders);
        this.total_orders += data.total_orders;
        this.initalOrderPoll = false;
        this.lastPollDateTime = currentDateTime;
        this.audio.play();
      }
      catch(e){
        console.log(e);
      }
      this.showoverlay = false;
    },

    changePage() {
      this.showoverlay = true;
      this.fetchOrders();
    },

    // if returned from Stripe auth then re-route to settings page
    checkStripeAuth() {
      var success = location.search.split('success=')[1];
      if (success=='true') {
        this.$router.push({name: 'Settings', query: {success: true}});
      }
    },

    showFilters(vis) {
      var o = document.getElementById("orderscrn");
      if (vis == true) {
        o.classList.add("filter-padding")
      } else {
        o.classList.remove("filter-padding")
      }
    },

    updateStatusFilter(statusfilter) {
      if (statusfilter=='') {
        // empty filter url string if no items selected
        this.statusfilter='';
      } else {
        var filter = '&status=in:';
        // build comma separated list of statuses
        for (const [i, val] of statusfilter.entries()) {
          if (i === 0) {
            filter+=String(val);
          } else {
            filter+=','+String(val);
          }
        }
        this.statusfilter = filter;
      }
      this.showoverlay = true;
      this.fetchOrders();
    },

    updateTextFilter(textfiltervalue, textfiltertype) {
      if (textfiltervalue == '') {
        this.textfilter = '';
      } else {
        this.textfilter = '&'+textfiltertype+'=like:'+textfiltervalue;
      }
      this.showoverlay = true;
      this.fetchOrders();
    },

    updateSortParams(sortparam, sortbydesc) {
      if (sortparam=='') {
        this.sortparams='';
      } else {
        var sortdir = (sortbydesc === true) ? '-' : '+';
        this.sortparams = '&sortby=' + sortdir + sortparam;
      }
      this.showoverlay = true;
      this.fetchOrders();
    },

  },

  beforeDestroy () {
    clearInterval(this.timer)
  },

  mounted: async function() {
    if (localStorage.submittedFilter) {
      await this.fetchLocations();
      this.filterSubmitted = localStorage.submittedFilter;
    }
  },

  created: function() {
    this.showoverlay = true;
    this.checkStripeAuth();
    this.fetchLocations();
    this.timer = setInterval(this.pollForOrders, 60000)
  },

};
</script>
<style>

  @import '../styles/style.css';


</style>
